var render = function render(){var _vm=this,_c=_vm._self._c;return _c('supplier-table',{attrs:{"user-id":_vm.userId,"token":_vm.token}})
}
var staticRenderFns = []

export { render, staticRenderFns }